import { schema } from 'normalizr';

export const HOUR_SCHEMA_KEY = 'hour' as const;
export const PROJECT_SCHEMA_KEY = 'project' as const;
export const CLIENT_SCHEMA_KEY = 'client' as const;

export const projectSchema = new schema.Entity(
  PROJECT_SCHEMA_KEY,
  {},
  {
    idAttribute: value => {
      return value.id;
    },
  }
);
export const clientSchema = new schema.Entity(
  CLIENT_SCHEMA_KEY,
  {},
  {
    idAttribute: value => {
      return value.id;
    },
  }
);

export const hourSchema = new schema.Entity(HOUR_SCHEMA_KEY, {
  // users: [userSchema],
  project: projectSchema,
  client: clientSchema,
});

export const hourListSchema = [hourSchema];
